var abena = abena || {},
    e = e || {},
    dataLayer = dataLayer || {};
( function () {
    'use strict';
    jQuery( function () {
        abena.init();
    } );
    abena.init = function () {
        abena.stepguide.init();
        abena.navigation.init();
        abena.forms.init();
        abena.checkout.init();
        abena.formValidation();
        abena.validateAddresses();
        abena.plugin.popupCookie.init();
        abena.UserManagementEditFormAddFullName();
        abena.ecomNav();
        //abena.newsletterpopupgatracking();
    };
    e.ecom.checkout.init = function () {
        e.ecom.checkout.cart();
        e.ecom.checkout.shipping.SHIP11 = { // Verzending binnen Nederland
            onInit: [ e.ecom.checkout.delivery.alternate.init ],
            onSelectCallbacks: [ e.ecom.checkout.delivery.alternate.show ],
            onDeselectCallbacks: [ e.ecom.checkout.delivery.clear, e.ecom.checkout.delivery.alternate.hide, e.ecom.checkout.delivery.address.hide ]
        };
        e.ecom.checkout.delivery();
        e.ecom.checkout.payment();
        e.ecom.checkout.approve();
        e.ecom.checkout.receipt();
        e.ecom.checkout.receipt();
        e.ecom.checkout.delivery.address.init();
    };
    abena.formValidation = function () {
        jQuery( 'form.validate:not([id=mc-embedded-subscribe-form])' ).not( '.stdvalidate' ).validate( {
            submitHandler: function ( form ) {
                form.action = '/Admin/Public/FormMail.aspx?mode=20';
                form.submit();
            }
        } );
    };
    abena.validateAddresses = function () {
        if ( jQuery( '#AddressForm' ).length ) {
            jQuery( '#AddressForm' ).validate();
        }
    };

    abena.ecomNav = function () {
        ecomNav: (function() {
            var linkContainer = document.getElementsByClassName("ecom-group-navigation")[0]
            var bcrumbContainer = document.getElementsByClassName("breadcrumb hidden-phone")[0]
            if(linkContainer && bcrumbContainer) {
                var bcrumbs = Array.from(bcrumbContainer.getElementsByTagName("li"));
                var links = Array.from(linkContainer.getElementsByTagName("li"));
                var found = false;
                for(var i = bcrumbs.length - 1; i >= 0; i--) {
                    console.log("searching...");
                    links.forEach(function(ele, index) {
                        if(bcrumbs[i].innerText.replaceAll("/", "").trim().toLowerCase() == ele.innerText.replaceAll("/", "").trim().toLowerCase()) {
                            ele.children[0].classList.add("active");
                            found = true;
                        }
                    });
                    if(found) {
                        console.log("found");
                        break;
                    }
                }
            }
        })()
    };

    abena.plugin = {};
    abena.plugin.popupCookie = {
        check: function () {
            var jId = parseInt( jQuery( '#PopupModal' ).data( 'id' ) );
            if ( parseInt( jQuery.cookie( 'popupCookie' ) ) !== jId ) {
                jQuery( '.modal-popup' ).on( 'hide', function () {
                    jQuery.cookie( 'popupCookie', jId, {
                        expires: 30
                    } );
                } ).modal();
            }
        },
        disableOnShow: function () {
            jQuery( '.modal-popup' ).on( 'show', function () {
                jQuery.cookie( 'popupCookie', false, {
                    expires: 30
                } );
            } );
            if ( jQuery.cookie( 'popupCookie' ) === undefined || jQuery.cookie( 'popupCookie' ) === null ) {
                jQuery( '.modal-popup' ).modal();
            }
        },
        init: function () {
            //this.check();
            this.disableOnShow();
        }
    };
    abena.navigation = {
        megamenu: function () {
            jQuery( '.e-megamenu > ul ' ).find( 'li' ).each( function () {
                var jLink = jQuery( this ).find( 'a' ),
                    jLinkCounter = 0;
                jLink.wrapInner( '<span></span>' );
                jLink.on( 'click', function ( event ) {
                    if ( !jQuery( this ).next( 'ul' ).length ) {
                        event.stopPropagation();
                        event.preventDefault();
                        location.href = jQuery( this ).attr( 'href' );
                        jLinkCounter = 0;
                    }
                    else {
                        jLinkCounter++;
                        //console.log( jLinkCounter );
                        if ( jLinkCounter === 2 ) {
                            event.stopPropagation();
                            event.preventDefault();
                            location.href = jQuery( this ).attr( 'href' );
                        }
                    }
                } );
            } );
        },
        is_touch_device: function () {
            return 'ontouchstart' in window || navigator.maxTouchPoints;
        },
        hover: function () {
            if ( this.is_touch_device() === 0 ) {
                jQuery( '[data-toggle="dropdown"]' ).dropdownHover().on( 'click', function ( event ) {
                    event.preventDefault();
                    location.href = jQuery( this ).attr( 'href' );
                } );
            }
        },
        init: function () {
            this.megamenu();
            this.hover();
        }
    };
    abena.forms = {
        init: function () {
            var jSampleSelect = jQuery( 'select[name^="sample"]' );
            jSampleSelect.on( 'change', function () {
                jSampleSelect.find( 'option' ).prop( 'disabled', false );
                jSampleSelect.each( function () {
                    if ( this.selectedIndex !== 0 ) {
                        jSampleSelect.not( this ).find( 'option[value="' + this.value + '"]' ).prop( 'disabled', true );
                    }
                } );
            } );
        }
    };
    abena.checkout = {
        freeFreight: function () {
            if ( jQuery( '.js-free-freight-current' ).length ) {
                var jTotal = parseFloat( jQuery( '.js-free-freight-current' ).data( 'total' ).replace( ',', '.' ) ).toFixed( 2 ),
                    jCurrent = parseFloat( jQuery( '.js-free-freight-current' ).data( 'limit' ) ).toFixed( 2 ) - jTotal;
                jQuery( '.js-free-freight-current' ).html( parseFloat( jCurrent ).toFixed( 2 ) );
            }
        },
        renderNextBtn: function () {
            if ( jQuery( '.js-nextcheckout-step' ).length ) {
                jQuery( '.js-nextcheckout-step' ).show();
            }
        },
        checkForInfoLastStep: function () {
            var jCheck = jQuery( '.js-check-for-order-details' );
            if ( jCheck.length ) {
                var jCheckText = jQuery.trim( jCheck.text() );
                if ( jCheckText === '' ) {
                    jQuery.ajax( {
                        url: '/Default.aspx?ID=13364',
                        type: 'POST',
                        data: {
                            OrderID: jCheck.data( 'id' ),
                            OrderIP: jCheck.data( 'ip' ),
                            Token: 'V6wVYU6ytWr5'
                        },
                    } );
                }
            }
        },
        recurringOrder: function () {
            jQuery( 'input[name="EcomRecurringOrderCreate"]' ).on( 'change', function () {
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    jQuery( '.js-recurring-order-panel' ).slideDown( 150 );
                }
                else {
                    jQuery( '.js-recurring-order-panel' ).slideUp( 150 );
                }
            } );
            if ( jQuery( 'input[name="EcomRecurringOrderCreate"]' ).is( ':checked' ) === true ) {
                jQuery( 'input[name="EcomRecurringOrderCreate"]' ).prop( 'checked', true ).trigger( 'change' );
            }
        },
        setCountryCode: function () {
            if ( jQuery( '.js-e-country-code' ).length ) {
                if ( jQuery( 'input[name="CustomerAddressIsDeliveryAddress"][value="false"]' ).is( ':checked' ) ) {
                    if ( jQuery( 'select[name="EcomOrderDeliveryCountry"]' ).val() ) {
                        jQuery( '.js-e-country-code' ).val( jQuery( 'select[name="EcomOrderDeliveryCountry"]' ).val() );
                    }
                }
                jQuery( 'select[name="EcomOrderCustomerCountry"], select[name="EcomOrderDeliveryCountry"]' ).on( 'change', function () {
                    if ( jQuery( 'input[name="CustomerAddressIsDeliveryAddress"][value="true"]' ).is( ':checked' ) ) {
                        jQuery( '.js-e-country-code' ).val( jQuery( 'select[name="EcomOrderDeliveryCountry"]' ).val() );
                    }
                    else {
                        jQuery( '.js-e-country-code' ).val( jQuery( 'select[name="EcomOrderCustomerCountry"]' ).val() );
                    }
                } );
            }
        },
        setCustomerInfoAsDeliveryInfo: function () {
            if ( jQuery( 'form[name="CheckoutDeliveryForm"]' ).length ) {
                var checkoutForm = jQuery( 'form[name="CheckoutDeliveryForm"]' );
                jQuery( 'input[name="CustomerAddressIsDeliveryAddress"]' ).change( function () {
                    if ( this.value === 'false' ) {
                        var fieldsToCopy = [ 'FirstName', 'Surname' ];
                        jQuery.each( fieldsToCopy, function () {
                            var billingFieldName = jQuery( 'input[name="EcomOrderCustomer' + this + '"' );
                            var deliveryFieldName = jQuery( 'input[name="EcomOrderDelivery' + this + '"' );
                            deliveryFieldName.val( billingFieldName.val() );
                        } );
                        if ( jQuery( '#BillingAddress select[name="ecomOrderUserTitle"]' ).val() ) {
                            var userTitleVal = jQuery( '#BillingAddress #ecomOrderUserTitle' ).val();
                            jQuery( 'select[name="ecomOrderDeliveryUserTitle"] option[value=' + userTitleVal + ']' ).prop( 'selected', true );
                        }
                    }
                } );
                jQuery( checkoutForm ).data( 'validator' ).settings.submitHandler = function ( form ) {
                    if ( jQuery( '#EcomOrderCustomerName' ).attr( 'type' ) === 'hidden' ) {
                        var firstName = jQuery( '#EcomOrderCustomerFirstName' ).val();
                        var lastName = jQuery( '#EcomOrderCustomerSurname' ).val();
                        var fullNameList = [ firstName, lastName ];
                        var fullName = fullNameList.filter( String ).join( ' ' );
                        jQuery( '#EcomOrderCustomerName' ).val( fullName );
                    }
                    if (jQuery('#EcomOrderHouseNumberExport').attr( 'type' ) === 'hidden') {
                            var houseNumber = jQuery('#EcomOrderCustomerHouseNumber').val();
                            jQuery('#EcomOrderHouseNumberExport').val(houseNumber);
                    }

                    if ( jQuery( 'input[name="CustomerAddressIsDeliveryAddress"][value="true"]' ).is( ':checked' ) === true ) {
                        jQuery( '#BillingAddress' ).find( 'input' ).each( function () {
                            var billingFieldValue = jQuery( this ).val();
                            var billingFieldName = jQuery( this ).attr( 'name' );
                            var deliveryFieldName = billingFieldName.replace( 'Customer', 'Delivery' );
                            if ( jQuery( '#DeliveryAddress' ).find( 'input[name="' + deliveryFieldName + '"]' ) ) {
                                jQuery( 'input[name="' + deliveryFieldName + '"]' ).val( billingFieldValue );
                            }
                        } );
                        var userTitleVal = jQuery( '#BillingAddress #ecomOrderUserTitle' ).val();
                        jQuery( 'select[name="ecomOrderDeliveryUserTitle"] option[value=' + userTitleVal + ']' ).prop( 'selected', true );
                        var countryVal = jQuery( '#BillingAddress' ).find( 'select[name="EcomOrderCustomerCountry"]' ).val();
                        jQuery( 'select[name="EcomOrderDeliveryCountry"] option[value=' + countryVal + ']' ).prop( 'selected', true );
                    }
                    else {
                        if ( jQuery( '#EcomOrderDeliveryName' ).attr( 'type' ) === 'hidden' ) {
                            var firstName = jQuery( '#EcomOrderDeliveryFirstName' ).val();
                            var lastName = jQuery( '#EcomOrderDeliverySurname' ).val();
                            var fullNameList = [ firstName, lastName ];
                            var fullName = fullNameList.filter( String ).join( ' ' );
                            jQuery( '#EcomOrderDeliveryName' ).val( fullName );
                        }
                    }
                    if (jQuery('#EcomOrderDeliveryHouseNumberExport').attr( 'type' ) === 'hidden') {
                            var houseNumber = jQuery('#EcomOrderDeliveryHouseNumber').val();
                            jQuery('#EcomOrderDeliveryHouseNumberExport').val(houseNumber);
                    }
                    form.submit();
                };
            }
        },
        init: function () {
            this.recurringOrder();
            this.renderNextBtn();
            this.checkForInfoLastStep();
            this.freeFreight();
            this.setCountryCode();
            this.setCustomerInfoAsDeliveryInfo();
        }
    };
    e.ecom.checkout.delivery.address = {
        init: function () {
            this.multiple();
        },
        show: function () {
            jQuery( '#DeliveryAddress' ).parent().slideDown( 'fast' );
        },
        hide: function () {
            var jEcomOrderCustomerCountry = jQuery( '#EcomOrderCustomerCountry' ),
                jEcomOrderDeliveryCountry = jQuery( '#EcomOrderDeliveryCountry' );
            //console.log( jEcomOrderCustomerCountry.data( 'selected' ), jEcomOrderDeliveryCountry.data( 'selected' ), jEcomOrderDeliveryCountry.data( 'selected' ), jEcomOrderCustomerCountry.val() );
            /*
            Ingen grund til reload hvis:
            Der ikke er valgt et leveringsland, eller
            leveringslandet er det samme som kundes land, og
            der ikke er ændret på kundens land efter siden er indlæst
            */
            if ( jEcomOrderDeliveryCountry.data( 'selected' ) !== '' && ( jEcomOrderCustomerCountry.data( 'selected' ) === jEcomOrderDeliveryCountry.data( 'selected' ) && jEcomOrderCustomerCountry.data( 'selected' ) === jEcomOrderCustomerCountry.val() ) === false ) {
                //console.log( 'hide // reload' );
                //e.ecom.checkout.delivery.reload();
                e.ecom.checkout.delivery.address.clear();
            }
            else {
                //console.log( 'hide // do nothing' );
            }
            jQuery( '#DeliveryAddress' ).parent().hide();
        },
        reset: function () {
            e.util.formFieldsResetToDefault( jQuery( '#DeliveryAddress' ).find( ':input' ) );
        },
        clear: function () {
            //console.log( 'e.ecom.checkout.alternate.clear' );
            jQuery( '#DeliveryAddress' ).find( ':input' ).val( '' );
        },
        multiple: function () {
            if ( jQuery( '#DeliveryAddressExtranet' ).hasClass( 'refreshOnSelect' ) ) {
                jQuery( '#DeliveryAddressExtranet' ).find( 'input[name="CustomerAlternativeDeliveryAddress"]' ).on( 'change', function () {
                    jQuery( this ).parent( 'label' ).find( 'span' ).each( function () {
                        var customerAlternativeDeliveryAddressField = jQuery( this ).data( 'field' );
                        if ( customerAlternativeDeliveryAddressField === 'EcomOrderDeliveryCountry' ) {
                            jQuery( '#DeliveryAddress' ).find( 'select#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
                            if ( !jQuery( 'input[name="EcomOrderDeliveryName"]' ).val() ) {
                                jQuery( 'input[name="EcomOrderDeliveryName"]' ).val( jQuery( 'input[name="EcomOrderCustomerName"]' ).val() );
                            }
                            jQuery( '#DeliveryAddress' ).find( 'select#' + customerAlternativeDeliveryAddressField );
                        }
                        else {
                            jQuery( '#DeliveryAddress' ).find( 'input#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
                        }
                        //.trigger('change');
                    } );
                } ).filter( ':checked' ).triggerHandler( 'change' );
            }
            else {
                jQuery( '#DeliveryAddressExtranet' ).find( 'input[name="CustomerAlternativeDeliveryAddress"]' ).on( 'change', function () {
                    jQuery( this ).parent( 'label' ).find( 'span' ).each( function () {
                        var customerAlternativeDeliveryAddressField = jQuery( this ).data( 'field' );
                        if ( customerAlternativeDeliveryAddressField === 'EcomOrderDeliveryCountry' ) {
                            jQuery( '#DeliveryAddress' ).find( 'select#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
                            if ( !jQuery( 'input[name="EcomOrderDeliveryName"]' ).val() ) {
                                jQuery( 'input[name="EcomOrderDeliveryName"]' ).val( jQuery( 'input[name="EcomOrderCustomerName"]' ).val() );
                            }
                            jQuery( '#DeliveryAddress' ).find( 'select#' + customerAlternativeDeliveryAddressField ).trigger( 'change' );
                        }
                        else {
                            jQuery( '#DeliveryAddress' ).find( 'input#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
                        }
                        //.trigger('change');
                    } );
                } ).filter( ':checked' ).triggerHandler( 'change' );
            }
        }
    };
    abena.stepguide = {
        onSiteLoad: function () {
            var cookieSet = jQuery.cookie( 'currentStepv2' ),
                cookieCheck = jQuery.cookie( 'stepGuidev2' ),
                stepguideID = jQuery( '.abena-filters' ).data( 'id' ),
                currentStepNumber = 0,
                lastStepNumber = jQuery( '.steplist' ).find( 'a' ).length;
            if ( jQuery( '.abena-filters' ).length ) {
                jQuery.cookie( 'stepGuidev2', stepguideID );
                if ( cookieCheck !== null && cookieCheck !== 'null' ) {
                    if ( parseInt( cookieCheck ) !== stepguideID ) {
                        jQuery.cookie( 'currentStepv2', null );
                        jQuery( '.reset-all-filters' ).trigger( 'click' );
                    }
                }
                if ( cookieSet !== null && cookieSet !== 'null' ) {
                    currentStepNumber = parseInt( cookieSet );
                }
                else {
                    currentStepNumber = 1;
                    jQuery.cookie( 'currentStepv2', 1 );
                }
                if ( currentStepNumber !== lastStepNumber ) {
                    jQuery( 'button.next-filter' ).show();
                    if ( currentStepNumber > 1 ) {
                        jQuery( 'a.prev-filter' ).show();
                    }
                }
                else {
                    jQuery( 'button.last-filter' ).show().on( 'click', function () {
                        jQuery.cookie( 'currentStepv2', ( lastStepNumber + 1 ) );
                    } );
                }
                if ( currentStepNumber === ( lastStepNumber + 1 ) ) {
                    jQuery( '.js-abena-filter-grid' ).fadeIn();
                    jQuery( '.next-filter' ).hide();
                    jQuery( '.prev-filter' ).show();
                    jQuery( 'div.steps-completed' ).fadeIn();
                    //jQuery('.steplist').hide();
                    jQuery( '.js-steplist-search-result' ).show();
                }
                jQuery( '.steplist' ).find( 'a[data-step="' + currentStepNumber + '"]' ).addClass( 'active' );
                jQuery( '.steplist-content' ).find( 'li[data-step="' + currentStepNumber + '"]' ).show();
                jQuery( 'button.next-filter' ).data( 'nextstep', currentStepNumber + 1 );
                jQuery( 'a.prev-filter' ).data( 'nextstep', currentStepNumber - 1 );
                //jQuery('.js-steplist-product-counter').html(productCount);
                var activeList = jQuery( '.steplist-content' ).find( 'li:visible' );
                if ( activeList.find( 'label.filter-label' ).length === activeList.find( 'label.filter-label.disabled' ).length ) {
                    activeList.find( 'fieldset' ).next( '.js-alert' ).show();
                    if ( currentStepNumber !== 1 && currentStepNumber < ( lastStepNumber + 1 ) ) {
                        //jQuery( 'button.next-filter' ).hide();
                        jQuery( 'a.prev-filter' ).show();
                    }
                    else {
                        //jQuery( 'button.next-filter' ).prop( 'disabled', true );
                    }
                }
            }
            else {
                jQuery.cookie( 'currentStepv2', null );
                jQuery.cookie( 'stepGuidev2', null );
            }
        },
        toggle: function () {
            jQuery( '.steplist' ).find( 'a' ).on( 'click', function () {
                var stepNumber = jQuery( this ).data( 'step' );
                jQuery.cookie( 'currentStepv2', stepNumber );
                jQuery( '.e-productlist-filters' ).find( 'form' ).trigger( 'submit' );
            } );
            jQuery( 'button.next-filter, a.prev-filter' ).on( 'click', function ( event ) {
                var nextstepNumber = jQuery( this ).data( 'nextstep' );
                event.preventDefault();
                jQuery( '.steplist' ).find( 'a[data-step="' + nextstepNumber + '"]' ).trigger( 'click' );
            } );
        },
        resetAll: function () {
            jQuery( 'a.reset-all-filters' ).on( 'click', function () {
                jQuery.cookie( 'currentStepv2', null );
            } );
        },
        init: function () {
            this.onSiteLoad();
            this.toggle();
            this.resetAll();
        }
    };
    e.util.galleries.fullscreen = {
        init: function () {
            this.jGallery = jQuery( '.js-e-gallery-fullscreen' ).first();
            if ( this.jGallery.length === 1 ) {
                this.jSlides = this.jGallery.find( '.js-e-gallery-fullscreen-slides > div' );
                this.jControls = this.jGallery.find( '.js-e-gallery-fullscreen-controls > div' );
                this.hideObstructions();
                this.setSizes();
                this.initSlides();
                this.initControls();
                this.bindEvents();
            }
        },
        bindEvents: function () {
            if ( this.jControls.length > 1 ) {
                this.jControls.on( 'mouseenter', function () {
                    var activeIndex = e.util.galleries.fullscreen.jControls.index( this );
                    e.util.galleries.fullscreen.goToSlide( activeIndex );
                } );
            }
            e.constant.jWindow.on( 'resize', function () {
                e.util.galleries.fullscreen.setSizes();
            } );
        },
        initSlides: function () {
            var jThisSlide = this.jSlides.first();
            setTimeout( function () {
                jThisSlide.addClass( 'active' );
            }, 500 ); //TODO: skal være afhængig af controlsEntryInterval
        },
        initControls: function () {
            var controlsEntryInterval = 150; //TODO: flyttes ud i en setting
            setTimeout( function () {
                e.util.galleries.fullscreen.jControls.each( function ( index ) {
                    var jThis = jQuery( this );
                    setTimeout( function () {
                        jThis.removeClass( 'inactive' );
                        if ( index === e.util.galleries.fullscreen.jControls.length - 1 ) {
                            e.util.galleries.fullscreen.goToSlide( 0 );
                        }
                    }, controlsEntryInterval * index - controlsEntryInterval / 4 * index );
                } );
            }, controlsEntryInterval * 5 );
        },
        goToSlide: function ( index ) {
            var jThisControl = this.jControls.eq( index ),
                jThisSlide = this.jSlides.eq( index );
            jThisControl.addClass( 'active' );
            jThisSlide.addClass( 'active' );
            this.jControls.not( jThisControl ).removeClass( 'active' );
            this.jSlides.not( jThisSlide ).removeClass( 'active' );
            clearTimeout( this.shadowSlideTimeout );
            this.shadowSlideTimeout = setTimeout( function () {
                jThisSlide.parent().css( 'background-image', jThisSlide.css( 'background-image' ) );
            }, 750 ); //TODO: bør beregnes udfra øvrige vars
        },
        getVisibleHeight: function () {
            var visibleHeight = e.constant.jWindow.height();
            jQuery( 'body' ).children( 'div' ).filter( ':visible' ).not( '.e-wrapper' ).each( function () {
                var jThis = jQuery( this );
                if ( e.util.isInViewport( jThis ) === true ) {
                    //console.log( jThis.outerHeight(), jThis );
                    visibleHeight = visibleHeight - jThis.outerHeight();
                }
            } );
            return visibleHeight;
        },
        setSizes: function () {
            var jWrapper = jQuery( '.e-wrapper' ),
                visibleHeight = this.getVisibleHeight(),
                pageTop = jWrapper.position().top - 1,
                gutterWidth = 2; //TODO: flyttes ud i en setting
            this.pageWidth = jWrapper.innerWidth();
            jWrapper.css( {
                'margin-top': visibleHeight
            } );
            this.jGallery.css( {
                'position': 'absolute',
                'top': pageTop,
                'padding': 0,
                'height': visibleHeight + 2
            } );
            this.jControls.parent().css( {
                'width': this.pageWidth / 2,
                'margin': '0 auto',
            } );
            if ( this.jControls.length > 1 ) {
                var controlWidth = parseInt( ( this.pageWidth - ( ( this.jControls.length - 1 ) * gutterWidth ) ) / this.jControls.length, 10 );
                this.jControls.each( function ( index ) {
                    jQuery( this ).css( {
                        'width': controlWidth,
                        'left': ( controlWidth * index ) + ( index === 0 ? 0 : gutterWidth * index )
                    } );
                } );
            }
        },
        hideObstructions: function () {
            jQuery( 'body' ).css( 'background-image', 'none' );
            this.jGallery.parents( '.row' ).css( {
                'height': 0,
                'min-height': 0,
                'margin-bottom': 0
            } );
            jQuery( '.js-e-newsletter-popup-teaser, .js-e-newsletter-popup-container, .e-breadcrumb' ).remove();
        }
    };
    abena.UserManagementEditFormAddFullName = function () {
        if ( jQuery( '#UserManagement_Form_Name' ).attr( 'type' ) === 'hidden' ) {
            jQuery( 'form[name="UserManagementEditForm"]' ).data( 'validator' ).settings.submitHandler = function ( form ) {
                var firstName = jQuery( '#UserManagement_Form_FirstName' ).val();
                var lastName = jQuery( '#UserManagement_Form_LastName' ).val();
                var fullNameList = [ firstName, lastName ];
                var fullName = fullNameList.filter( String ).join( ' ' );
                jQuery( '#UserManagement_Form_Name' ).val( fullName );
                form.submit();
            };
        }
    };
    e.newsletterpopup.form.emailMarketing = function ( jForm ) {
        var response = jQuery( '.js-e-newsletter-comfirm-msg' ).html();
        jQuery.ajax( {
            type: 'POST',
            url: '/',
            data: jForm.serialize(),
            beforeSend: function () {
                e.newsletterpopup.form.loading( jForm );
            },
            success: function () {
                e.newsletterpopup.success( response );
                abena.newsletterpopupgatracking();
            }
        } );
        return false;
    };
    abena.newsletterpopupgatracking = function () {
        dataLayer.push( {
            'event': 'googleAnalyticsEvent',
            'eventCategory': 'form',
            'eventAction': 'hulp',
            'eventLabel': ''
        } );
    };
}() );